import classNames from 'classnames';
import React, { FC, useCallback, useState } from 'react';
import { PolicyPaymentMethod } from 'Policies/components/PolicyPaymentMethod';
import { FormInput } from 'Shared/components';
import styles from './styles.module.css';
import { formatMoney } from 'Shared/utils';
import { PaymentsAndBillingInfoType } from '@clearcover/core-app-types';

type PaymentFormValues = {
  paymentMethodId: string;
  paymentAmount: number;
};

type PaymentFormProps = {
  billingInfo: PaymentsAndBillingInfoType;
  amountDueToday: number;
  fetchBillingData?: () => Promise<void>;
  values: PaymentFormValues;
  setFieldValue: (field: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
};

export const PaymentForm: FC<PaymentFormProps> = ({
  billingInfo,
  amountDueToday,
  fetchBillingData,
  values,
  setFieldValue,
  handleChange,
}) => {
  const initialPaymentOption = 'AmountDueToday';
  const [paymentOption, setPaymentOption] = useState(initialPaymentOption);

  const setPaymentAmount = useCallback(
    (
      selectedOption: string,
      setFieldValue: (field: string, value: any) => void
    ) => {
      const paymentAmount: number =
        selectedOption === 'AmountDueToday' ? amountDueToday : 0;

      setFieldValue('paymentAmount', paymentAmount);
    },
    [amountDueToday]
  );

  return (
    <div className={styles.paymentTypeMethodAmountContainer}>
      <div className={styles.payment}>
        <div className={styles.summaryHeader}>Payment Type</div>
        <label className={styles.paymentLabel}>Choose an option</label>
        <FormInput
          variant="radioGroup"
          name="payment-type"
          data-testid="payment-type"
          className={styles.paymentRadioGroup}
          onChange={(newPaymentOption: string) => {
            setPaymentOption(newPaymentOption);
            setPaymentAmount(newPaymentOption, setFieldValue);
          }}
          value={paymentOption}
          label=""
          options={{
            AmountDueToday: 'Amount Due Today - ' + formatMoney(amountDueToday),
          }}
        />
      </div>
      <div className={styles.payment} data-testid="payment-method-section">
        <div className={styles.summaryHeader}>Payment Method</div>
        <label className={styles.paymentLabel}>Select Payment Type</label>
        <div className={styles.paymentMethodPicker}>
          <PolicyPaymentMethod
            policyPaymentMethods={billingInfo.paymentMethods}
            value={values.paymentMethodId}
            setValue={(newPaymentMethodId) => {
              setPaymentAmount(paymentOption, setFieldValue);
              setFieldValue('paymentMethodId', newPaymentMethodId);
            }}
            disabled={true} // TODO: this should be changed back to paymentOption === 'No Payment' when add payment method is implemented
            showAddPaymentMethod={false}
            fetchBillingData={fetchBillingData}
          />
        </div>
      </div>
      <div className={classNames(styles.payment, styles.paymentAmount)}>
        <div className={styles.summaryHeader}>Payment Amount</div>
        <label className={styles.paymentLabel}>Enter Payment Amount</label>
        <FormInput
          variant="text"
          name="paymentAmount"
          data-testid="payment-amount"
          onChange={handleChange}
          value={formatMoney(values.paymentAmount)}
          label="Payment Amount"
          disabled={true}
        />
      </div>
    </div>
  );
};
